// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-largeOnConfined-button-4d8ea2e0","buttonLoading":"skins-largeOnConfined-buttonLoading-1a5c4f39"};